import axiosInstance from './axiosInstance';

const getPromotions = ({ active, manual }) =>
  axiosInstance.get('internal/admin/promotions', {
    params: { active, manual },
  });

export default getPromotions;
